import React from 'react';

import { Outlet } from 'react-router-dom';

const KitchenInventoryStockContent = () => {
  return <Outlet />;
};

export default KitchenInventoryStockContent;
